import Layout from "./Layout.jsx";
import Dashboard from "./Dashboard";
import Orders from "./Orders";
import Inventory from "./Inventory";
import Customers from "./Customers";
import Settings from "./Settings";
import PrintRuns from "./PrintRuns";
import BookStore from "./BookStore";
import PrintRunDetails from "./PrintRunDetails";
import Help from "./Help";
import Waitlist from "./Waitlist";
import Login from "./Login.jsx";
import PublicOrderPage from "./PublicOrderPage.jsx";
import PublicDocumentPage from "./PublicDocumentPage.jsx";
import { ProtectedRoute, PublicRoute } from "../components/ProtectedRoute.jsx";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

const PAGES = {
    Dashboard: Dashboard,
    Orders: Orders,
    Inventory: Inventory,
    Customers: Customers,
    Settings: Settings,
    PrintRuns: PrintRuns,
    BookStore: BookStore,
    PrintRunDetails: PrintRunDetails,
    Help: Help,
    Waitlist: Waitlist,
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    
    // Handle panel routes
    if (url.startsWith('/panel/')) {
        const panelPath = url.replace('/panel/', '');
        const pageName = Object.keys(PAGES).find(page => 
            page.toLowerCase() === panelPath.toLowerCase() ||
            page.toLowerCase() === panelPath.replace('-', '').toLowerCase()
        );
        return pageName || 'Dashboard';
    }
    
    // Handle root and store routes
    if (url === '/' || url === '/bookstore' || url === '/BookStore' || url === '/bookshop') {
        return 'BookStore';
    }
    
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || 'Dashboard';
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    // Don't calculate currentPage for public routes to avoid unnecessary re-renders
    const isPublicRoute = location.pathname === '/login' || 
                         location.pathname === '/BookStore' || 
                         location.pathname === '/bookstore' ||
                         location.pathname.startsWith('/documents/');
    
    return (
        <Routes>
            {/* Public routes */}
            <Route path="/login" element={
                <PublicRoute>
                    <Login />
                </PublicRoute>
            } />
            
            {/* Public store - root route */}
            <Route path="/" element={<BookStore />} />
            
            {/* Public store routes */}
            <Route path="/BookStore" element={<BookStore />} />
            <Route path="/bookstore" element={<BookStore />} />
            <Route path="/bookshop" element={<BookStore />} />
            
            {/* Public order page */}
            <Route path="/order/:id" element={<PublicOrderPage />} />

            {/* Public legal/consent documents */}
            <Route path="/documents/:type" element={<PublicDocumentPage />} />
            
            {/* Protected admin panel routes */}
            <Route path="/panel" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Dashboard />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/dashboard" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Dashboard />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/orders" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Orders />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/inventory" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Inventory />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/customers" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Customers />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/settings" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Settings />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/print-runs" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <PrintRuns />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/print-run-details" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <PrintRunDetails />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/help" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Help />
                    </Layout>
                </ProtectedRoute>
            } />
            
            <Route path="/panel/waitlist" element={
                <ProtectedRoute>
                    <Layout currentPageName={currentPage}>
                        <Waitlist />
                    </Layout>
                </ProtectedRoute>
            } />
        </Routes>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}
